import { combineReducers } from 'redux';
import * as actions from '../../actions/types';

const candybar = (state: never[] | null = null, action) => {
    switch (action.type) {
        case actions.USER_CANDYBAR_PURCHASES_FETCH_SUCCESS:
            return [].concat(action.data || []);
        case actions.USER_CANDYBAR_PURCHASES_FETCH:
        case actions.USER_CANDYBAR_PURCHASES_FETCH_ERROR:
            return null;
        default:
            return state;
    }
};
const purchasesLoading = (state = false, action) => {
    switch (action.type) {
        case actions.USER_PURCHASE_HISTORY_FETCH:
            return true;
        case actions.USER_PURCHASE_HISTORY_FETCH_SUCCESS:
        case actions.USER_PURCHASE_HISTORY_FETCH_ERROR:
            return false;
        default:
            return state;
    }
};

const candybarLoading = (state = false, action) => {
    switch (action.type) {
        case actions.USER_CANDYBAR_PURCHASES_FETCH:
            return true;
        case actions.USER_CANDYBAR_PURCHASES_FETCH_SUCCESS:
        case actions.USER_CANDYBAR_PURCHASES_FETCH_ERROR:
            return false;
        default:
            return state;
    }
};

const purchases = (state = [], action) => {
    switch (action.type) {
        case actions.USER_PURCHASE_HISTORY_FETCH:
        case actions.USER_PURCHASE_HISTORY_FETCH_ERROR:
            return [];
        case actions.USER_PURCHASE_HISTORY_FETCH_SUCCESS:
            return action.purchases;
        default:
            return state;
    }
};

export default combineReducers({
    candybar,
    candybarLoading,
    purchases,
    purchasesLoading,
});